function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread(); }
function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _iterableToArray(iter) { if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter); }
function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) return _arrayLikeToArray(arr); }
function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }
import _flatMapInstanceProperty from "@babel/runtime-corejs3/core-js/instance/flat-map";
import _setTimeout from "@babel/runtime-corejs3/core-js/set-timeout";
import _mapInstanceProperty from "@babel/runtime-corejs3/core-js/instance/map";
import _Number$isFinite from "@babel/runtime-corejs3/core-js/number/is-finite";
import React from "react";
import PropTypes from "prop-types";
var QueueContext = /*#__PURE__*/React.createContext();
export var useSnackbarQueueContext = function useSnackbarQueueContext() {
  return React.useContext(QueueContext);
};
export var useSnackbarQueue = function useSnackbarQueue() {
  var cleanTimer = React.useRef();
  var dismissTimer = React.useRef();
  var _React$useState = React.useState([]),
    _React$useState2 = _slicedToArray(_React$useState, 2),
    queue = _React$useState2[0],
    setQueue = _React$useState2[1];
  var first = queue[0];
  var clean = function clean(id) {
    setQueue(function (q) {
      return _flatMapInstanceProperty(q).call(q, function (el) {
        if (el.id === id && el.visible === false) {
          return [];
        }
        return el;
      });
    });
  };
  var timeoutClean = React.useCallback(function (id) {
    if (cleanTimer.current) {
      clearTimeout(cleanTimer.current);
    }
    cleanTimer.current = _setTimeout(function () {
      clean(id);
      cleanTimer.current = null;
    }, 500);
  }, []);
  var push = function push(el) {
    setQueue(function (q) {
      return [].concat(_toConsumableArray(q), [_objectSpread(_objectSpread({}, el), {}, {
        visible: true
      })]);
    });
  };
  var dismissFirst = React.useCallback(function (id) {
    setQueue(function (q) {
      var found = false;
      return _mapInstanceProperty(q).call(q, function (el) {
        if (el.id === id && el.visible && !found) {
          found = true;
          return _objectSpread(_objectSpread({}, el), {}, {
            visible: false
          });
        }
        return el;
      });
    });
    timeoutClean(id);
  }, [timeoutClean]);
  React.useEffect(function () {
    if (first && _Number$isFinite(first.dismissTimeout)) {
      dismissTimer.current = _setTimeout(function () {
        dismissFirst(first.id);
      }, first.dismissTimeout);
    }
    return function () {
      clearTimeout(dismissTimer.current);
    };
  }, [first, dismissFirst]);
  React.useEffect(function () {
    return function () {
      return clearTimeout(cleanTimer.current);
    };
  }, []);
  return React.useMemo(function () {
    return {
      push: push,
      getData: function getData(id) {
        if (id === (first === null || first === void 0 ? void 0 : first.id)) {
          return first.data;
        }
        return null;
      },
      isVisible: function isVisible(id) {
        var _queue$;
        return id === ((_queue$ = queue[0]) === null || _queue$ === void 0 ? void 0 : _queue$.id) && queue[0].visible === true;
      },
      dismissAll: function dismissAll(id) {
        setQueue(function (q) {
          return _mapInstanceProperty(q).call(q, function (el) {
            if (el.id === id && el.visible) {
              return _objectSpread(_objectSpread({}, el), {}, {
                visible: false
              });
            }
            return el;
          });
        });
        timeoutClean(id);
      },
      dismissFirst: dismissFirst,
      clean: clean
    };
  }, [queue, timeoutClean, dismissFirst, first]);
};
export var SnackbarProvider = function SnackbarProvider(_ref) {
  var children = _ref.children;
  var queue = useSnackbarQueue();
  return /*#__PURE__*/React.createElement(QueueContext.Provider, {
    value: queue
  }, children);
};
process.env.NODE_ENV !== "production" ? SnackbarProvider.propTypes = {
  children: PropTypes.node
} : void 0;